module.exports = __webpack_public_path__ + "static/media/inludidos.133f9175.jpeg";